 import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
// import Swal from 'sweetalert2';
import $ from "jquery";
import PropTypes from 'prop-types';

import { loader_image } from "../_components/Imagepath";
// import AWS from 'aws-sdk';
// import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

import {
  // Box,
  // Button,
  // ListItemIcon,
  MenuItem,
  // Typography,
  // TextField,
} from '@mui/material';
// import { AccountCircle, Send } from '@mui/icons-material';
// //import Button from '@mui/material/Button';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ClickAwayListener from '@mui/material/ClickAwayListener';
// import Grow from '@mui/material/Grow';
// import Paper from '@mui/material/Paper';
// import Popper from '@mui/material/Popper';
// //import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
const ViewProductionOutputGropyByPallet = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(51)); 
console.log(permission);

    axios
      .get(`/production-output/listing-groupby-pallettype/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.productions);
          setData(response.data.data.productions_all);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  const BarcodeCell = ({ row }) => (
    <a href={`/production-output-view/${row.original.id}`} className="">
      {row.original.barcode_number}
    </a>
  );
  
  BarcodeCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        barcode_number: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  };
  
  const CaliberCell = ({ row }) => {        
    const total_items = row.original.items || []; // Ensure it's an array
    const calibreDisplay = total_items.map(item => item.calibre).join(' / ');
  
    return <span>{calibreDisplay}</span>;
  };
  
  CaliberCell.propTypes = {
    row: PropTypes.shape({
      original: PropTypes.shape({
        items: PropTypes.arrayOf(
          PropTypes.shape({
            calibre: PropTypes.string
          })
        )
      }).isRequired
    }).isRequired
  };
  
  const columns = [
    {
      header: 'Barcode Number',
      accessorFn: (row) => `${row.barcode_number}`,
      Cell: BarcodeCell
    },
    {
      header: 'Caliber',
      Cell: CaliberCell
    },
    {
      accessorKey: 'date_time',
      header: 'Date Time',
    },
    {
      header: 'Location',
      accessorFn: (row) => `${row.location_name ? row.location_name.title : ''}`,
    },
    {
      accessorKey: 'shift',
      header: 'Shift',
    },
    {
      accessorKey: 'shift_date',
      header: 'Shift Date',
    },
    {
      header: 'Order PO Number',
      accessorFn: (row) => `${row.order_detail ? row.order_detail.po_number : ''}`,
    },
    {
      header: 'Pallet Type',
      accessorFn: (row) => `${row.pallet_type_title ? row.pallet_type_title.title : ''}`,
    },
    {
      header: 'Package Type',
      accessorFn: (row) => `${row.package_type ? row.package_type.title : ''}`,
    },
    {
      header: 'Created By',
      accessorFn: (row) =>
        `${row.createdby ? row.createdby.first_name + ' ' + row.createdby.last_name : ''}`,
    },
    {
      header: 'Updated By',
      accessorFn: (row) =>
        `${row.updatedby ? row.updatedby.first_name + ' ' + row.updatedby.last_name : ''}`,
    },
  ];
  // const columns =
  // [
   
  //     {
  //       header: 'Barcode Number',
  //       accessorFn: (row) => `${row.barcode_number}`,
  //       Cell: ({ renderedCellValue, row }) => {        
       
  //             return(
  //               <a href={'/production-output-view/'+row.original.id} className=""  >
  //                  {row.original.barcode_number}
  //               </a>
                
  //             )
  //           }
  //     },
  //     {
  //       header: 'Caliber',
  //       Cell: ({ row }) => {        
  //         const total_items = row.original.items || []; // Ensure it's an array
  //         const calibreDisplay = total_items.map(item => item.calibre).join(' / ');
  
  //         return (
  //           <span>{calibreDisplay} </span>
  //         );
  //       },
  //     },
  //     {
  //     accessorKey: 'date_time', //normal accessorKey
  //     header: 'Date Time',
  //   },
  //   {
  //     header: 'Location',
  //     accessorFn: (row) => `${(row.location_name)?row.location_name.title:""} `,
  //   },
  //   {
  //     accessorKey: 'shift', //normal accessorKey
  //     header: 'Shift',
  //   },
  //   {
  //     accessorKey: 'shift_date', //normal accessorKey
  //     header: 'Shift Date',
  //   },
  //   {
  //     header: 'Order PO Number',
  //     accessorFn: (row) => `${(row.order_detail)?row.order_detail.po_number:""} `,
  //   },
  //   {
  //     header: 'Pallet Type',
  //     accessorFn: (row) => `${(row.pallet_type_title)?row.pallet_type_title.title:""} `,
  //   },
  //   {
  //     header: 'Package Type',
  //     accessorFn: (row) => `${(row.package_type)?row.package_type.title:""} `,
  //   },
  
  //   {
  //     header: 'Created By',
  //     accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
  //   },
  //   {
  //     header: 'Updated By',
  //     accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
  //   },
  //  ];
  //  const viewItem = (item)=>{
  //   window.location.href = "/production-output-view/"+item;

  // }

  const editItem = (item)=>{
    window.location.href = "/production-output-edit/"+item;
  }

  const printPalletLabel = (item)=>{
    var id = item.id; 
    $("#loader-image2").removeClass('loader-hide');
  $("#loader-image2").addClass('loader-show');
  axios.get(`/production-output/pdf/${id}`, {
     responseType: 'blob',
    headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
 }).then(response => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      let file_name = item.barcode_number+'.pdf';
      link.download = file_name;
      link.click();
      $("#loader-image2").addClass('loader-hide');
      $("#loader-image2").removeClass('loader-show');
  })
  .catch(error => {
      console.error('Error downloading PDF:', error);
  });
   // alert(item);
  }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Production Output Group By Pallet Type</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-output">Production Output</Link>
                    </li>
                    <li className="breadcrumb-item active">
                       Production Output Group By Pallet Type
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          
            <div className="row">
                
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Number Of Pallets </div>
                          <div className="dash-counts">
                            <p>{value.num_pallets}</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-4 col-sm-6 col-12 d-flex">
                  <div className="card inovices-card w-100">
                    <div className="card-body">
                      <div className="dash-widget-header">
                        <div className="dash-count text-center">
                          <div className="dash-title"> Total Net Weight</div>
                          <div className="dash-counts">
                          <p>{value.net_weight_total}KG</p>
                          </div>
                        </div>
                      </div>
                    
                    </div>
                  </div>
                </div>
              
               
                      
                </div>
            
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Productions Output</h4>
                    <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          enableRowActions
                          //renderColumnActionsMenuItems 
                          renderRowActionMenuItems={({ row }) => [
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>,
                           <MenuItem key="view" onClick={() => printPalletLabel(row.original)}>
                           Print Pallet Label <img id="loader-image2" className="loader-image loader-hide" src={loader_image}/> 
                         </MenuItem>,
                          //   <MenuItem key="view" onClick={() => printBoxLabel(row.original.id)}>
                          //   Print Box Label
                          // </MenuItem>,
                          // <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                          //     Delete
                          //   </MenuItem>,
                          ]}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewProductionOutputGropyByPallet;
